import { AfterViewInit, Component } from '@angular/core';
import { Actions } from 'bqx-deal';
import { ApplicationFormAbstractService } from 'src/app/services/application-form/application-form.abstract.service';
import { AbstractAuthService } from 'src/app/services/auth/auth.abstract.service';
import { AbstractDealAnalyticsService } from 'src/app/services/deal-analytics/abstract-deal-analytics.service';

@Component({
    selector: 'app-home-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.css'],
    standalone: false
})
export class HomePageComponent implements AfterViewInit {
  public get displaySearch(): boolean {
    return this.authService.shouldHaveSearchAccess;
  }
  constructor(
    private authService: AbstractAuthService,
    private dealAnalyticsService: AbstractDealAnalyticsService,
    private applicationFormService: ApplicationFormAbstractService
  ) { }

  public clearSession(): void {
    sessionStorage.clear();
  }

  public newQuoteOnClick(event) {
    this.clearSession();
    this.dealAnalyticsService.postDealControlEvent(Actions.ButtonClick, 'New Quote', '/dashboard', 'Dashboard');
  }

  public newSearchOnClick(event) {
    this.applicationFormService.dashboardFlag = true;
    this.dealAnalyticsService.postDealControlEvent(Actions.ButtonClick, 'Search Quotes', '/dashboard', 'Dashboard');
  }

  ngAfterViewInit(): void {
    this.dealAnalyticsService.postDealPageEvent('/dashboard', 'Dashboard');
  }
}
